module.exports = __webpack_public_path__ + "media/warranty-claim/photos-fasteners-5b31f651.png";